import React, { Suspense, useContext } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { StoreContext } from "../contexts/Store";
import { observer } from "mobx-react";
import { connect } from "react-redux";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { useBodyClass } from "../hooks";
import { Menu, HomeView, TermsOfService, AdminAuthShell } from "./routes";
import { AUTH_PREFIX_PATH } from "./auth/constants";
import { ADMIN_PANEL_PREFIX_PATH } from "../constants";
import { MENU_PREFIX_PATH } from "./menu/constants";
import { generateLocalizedPaths } from "../helpers/generateLocalizedPaths";
import { getLanguageFromUrl } from "../helpers/languageUtils";
import { HelmetProvider } from "react-helmet-async";
import RouteFallback from "../components/RouteFallback";
// Direct file import: the constants barrel creates the MUI home theme, which
// would pull MUI into the main bundle.
import { TERMS_OF_SERVICE_PATH } from "./home-view/constants/homePath";

export const FeaturesNavigation = (props) => {
  const mainStore = useContext(StoreContext);
  const { location, direction } = props;
  const { lang } = mainStore.settings;
  const currentLang = lang ?? getLanguageFromUrl(location.pathname);
  const currentAppLocale = AppLocale[currentLang];

  useBodyClass(`dir-${direction}`);

  return (
    <HelmetProvider>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Suspense fallback={<RouteFallback />}>
          <Switch>
            <Route exact path={generateLocalizedPaths()}>
              <HomeView />
            </Route>
            <Route exact path={generateLocalizedPaths(TERMS_OF_SERVICE_PATH)}>
              <TermsOfService />
            </Route>
            <Route path={MENU_PREFIX_PATH}>
              <Menu />
            </Route>
            <Route
              path={[
                ...generateLocalizedPaths(AUTH_PREFIX_PATH),
                ...generateLocalizedPaths(ADMIN_PANEL_PREFIX_PATH),
              ]}
            >
              <AdminAuthShell
                antdLocale={currentAppLocale.antd}
                direction={direction}
                location={location}
              />
            </Route>
          </Switch>
        </Suspense>
      </IntlProvider>
    </HelmetProvider>
  );
};

const mapStateToProps = ({ theme }) => {
  const { direction } = theme;
  return { direction };
};

export default withRouter(
  connect(mapStateToProps)(observer(FeaturesNavigation)),
);
